module.exports = __webpack_public_path__ + "img/C8.a278f4b5.jpg";